const intro = [
  {
    title: "What is Data Structures? | What is Algorithm? | What is ADT?",
    link: "introductiontoDSA",
  },
  {
    title:
      "What is Algorithm? | Simple Example | Characteristics | Notion | Design & Analysis",
    link: "introductionToAlgorithms",
  },
  {
    title:
      "What is Algorithm Analysis? | Runtime Analysis | Rate of Growth | Types of Analysis | Asymptotic Notations",
    link: "introductiontoDSA",
  },
  {
    title: "How to find Time Complexity of your program?",
    link: "timeComplexity",
  },
]

const linkedLists = [
  {
    title:
      "What is Linked List Data Structure? | Operations | Types | Applications",
    link: "linkedLists",
  },
  {
    title: "Singly Linked Lists | Operations | C++ Implementation",
    link: "singlyLinkedLists",
  },
  {
    title: "Cicular Linked Lists | Operations | C++ Implementation",
    link: "circularLinkedLists",
  },
  {
    title: "Doubly Linked Lists | Operations | C++ Implementation",
    link: "doublyLinkedLists",
  },
]

const stacks = [
  {
    title:
      "What is Stack Data Structure? | Applications | Operations | C++ Implementation",
    link: "stack",
  },
  {
    title: "Stack using Linked Lists | Operations | C++ Implementation",
    link: "stackUsingLinkedLists",
  },
  {
    title: "Infix VS Postfix VS Prefix Expression | Why do we need them?",
    link: "infixPrefixPostfixExpressions",
  },
  {
    title: "Infix to Postfix Conversion | C++ Implementation",
    link: "infixToPostfix",
  },
  {
    title: "Infix to Prefix Conversion | C++ Implementation",
    link: "infixToPrefix",
  },
  {
    title: "Evaluation of Postfix & Prefix | C++ Implementation",
    link: "evaluationOfPostfix&Prefix",
  },
]

const queues = [
  {
    title:
      "What is Queue Data Structure? | Applications | Operations | C++ Implementation",
    link: "queue",
  },
  {
    title: "Queue using Linked Lists | Operations | C++ Implementation",
    link: "queueUsingLinkedLists",
  },
  {
    title: "Circular Queues | Operations | C++ Implementation",
    link: "circularQueues",
  },
  {
    title: "Priority Queues | Operations | C++ Implementation",
    link: "priorityQueues",
  },
]

const trees = [
  {
    title: "What is Tree Data Structure? | Types | Applications | Operations",
    link: "tree",
  },
  {
    title: "What are Binary Trees? | Types | Applications",
    link: "binaryTree",
  },
  {
    title:
      "What are Binary Search Trees? | Applications | Operations | C++ Implementation",
    link: "binarySearchTree",
  },
  {
    title:
      "What are Binary Heap? | Storage Representation | Applications | Operations | C++ Implementation",
    link: "binaryHeap",
  },
]

const graphs = [
  {
    title: "What is Graph Data Structure? | Types | Applications | Operations",
    link: "graph",
  },
  {
    title: "Graph Traversal Techniques | BFS | DFS | C++ Implementation",
    link: "graphTraversalTechniques",
  },
]

const searching = [
  {
    title:
      "Linear Search | Working Procedure | Time Complexity | C++ Implementation",
    link: "linearSearch",
  },
  {
    title:
      "Binary Search | Working Procedure | Time Complexity | C++ Implementation",
    link: "binarySearch",
  },
]

const sorting = [
  {
    title:
      "Bubble Sort | Working Procedure | Time Complexity | C++ Implementation",
    link: "bubbleSort",
  },
  {
    title:
      "Selection Sort | Working Procedure | Time Complexity | C++ Implementation",
    link: "selectionSort",
  },
  {
    title:
      "Merge Sort | Working Procedure | Time Complexity | C++ Implementation",
    link: "mergeSort",
  },
  {
    title:
      "Quick Sort | Working Procedure | Time Complexity | C++ Implementation",
    link: "quickSort",
  },
  {
    title:
      "Insertion Sort | Working Procedure | Time Complexity | C++ Implementation",
    link: "insertionSort",
  },
  {
    title:
      "Topological Sort | Working Procedure | Time Complexity | C++ Implementation",
    link: "topologicalSort",
  },
]

const stringMatching = [
  {
    title:
      "String Matching Using Brute Force Technique | Working Procedure | Time Complexity | C++ Implementation",
    link: "stringMatchingUsingBruteForceTechnique",
  },
  {
    title:
      "String Matching Using Horspool's Algorithm | Working Procedure | Time Complexity | C++ Implementation",
    link: "stringMatchingUsingHorspoolsAlgorithm",
  },
]

const dynamicProgramming = [
  {
    title:
      "Introduction to Dynamic Programming | Example with Fibonacci Series",
    link: "dynamicProgramming",
  },
  {
    title:
      "Warshall's Algorithm | Working Procedure | Time Complexity | C++ Implementation",
    link: "warshallsAlgorithm",
  },
  {
    title:
      "Floyd's Algorithm | Working Procedure | Time Complexity | C++ Implementation",
    link: "floydsAlgorithm",
  },
  {
    title:
      "Knapsack Problem | Working Procedure | Time Complexity | C++ Implementation",
    link: "knapsackProblem",
  },
]

const greedyTechnique = [
  {
    title:
      "Prim's Algorithm | Working Procedure | Time Complexity | C++ Implementation",
    link: "primsAlgorithm",
  },
  {
    title:
      "Kruskal's Algorithm | Working Procedure | Time Complexity | C++ Implementation",
    link: "kruskalsAlgorithm",
  },
  {
    title:
      "Dijkstra's Algorithm | Working Procedure | Time Complexity | C++ Implementation",
    link: "dijkstrasAlgorithm",
  },
]

export {
  intro,
  linkedLists,
  stacks,
  queues,
  trees,
  graphs,
  searching,
  sorting,
  stringMatching,
  dynamicProgramming,
  greedyTechnique,
}
